import styled from 'styled-components';
import tw from 'tailwind-styled-components';
import { ReactNode } from 'react';

const Svg = tw.svg`
  w-full
  h-auto
`;

export function MobileDownloadIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" height="18" viewBox="0 0 18 18" width="18">
      <g fill="currentColor">
        <path d="m13.2511 7.70325c.1131.09683.1131.29047 0 .4115l-4.07006 4.35365c-.11315.121-.27156.121-.3847 0l-4.07005-4.35365c-.11314-.12103-.11314-.31467 0-.4115l.45259-.48412c.09052-.12103.27155-.12103.3847 0l2.82543 3.11907v-7.79773c0-.14523.13578-.29047.27155-.29047h.63362c.15841 0 .27155.14524.27155.29047v7.79773l2.84807-3.11907c.1131-.12103.2942-.12103.3847 0z" />
        <path d="m3.27155 14.4913h11.45685s.2716.1452.2716.2905v.6777c0 .1695-.1358.2905-.2716.2905h-11.45685c-.1584 0-.27155-.121-.27155-.2905v-.6777c0-.1453.11315-.2905.27155-.2905z" />
      </g>
    </svg>
  );
}

export function IcalIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="36"
      height="36"
      viewBox="0 0 100 100"
    >
      <path
        fill="#fefdef"
        d="M70.645,82h-41.29C23.084,82,18,76.916,18,70.645v-41.29C18,23.084,23.084,18,29.355,18h41.29	C76.916,18,82,23.084,82,29.355v41.29C82,76.916,76.916,82,70.645,82z"
      ></path>
      <line
        x1="77.5"
        x2="77.5"
        y1="43.527"
        y2="47.527"
        fill="none"
        stroke="#1f212b"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
      ></line>
      <line
        x1="77.5"
        x2="77.5"
        y1="39.527"
        y2="41.527"
        fill="none"
        stroke="#1f212b"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
      ></line>
      <path
        fill="none"
        stroke="#1f212b"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        d="M77.5,50.527v18.671	c0,4.585-3.717,8.302-8.302,8.302H30.802c-4.585,0-8.302-3.717-8.302-8.302V39.527"
      ></path>
      <path
        fill="#e85654"
        d="M71,18.027H29c-6.075,0-11,4.925-11,11v6.5h64v-6.5C82,22.952,77.075,18.027,71,18.027z"
      ></path>
      <path
        fill="none"
        stroke="#1f212b"
        stroke-miterlimit="10"
        stroke-width="2"
        d="M70.645,82h-41.29C23.084,82,18,76.916,18,70.645	v-41.29C18,23.084,23.084,18,29.355,18h41.29C76.916,18,82,23.084,82,29.355v41.29C82,76.916,76.916,82,70.645,82z"
      ></path>
      <line
        x1="49.5"
        x2="81"
        y1="35.527"
        y2="35.527"
        fill="none"
        stroke="#1f212b"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
      ></line>
      <line
        x1="46.5"
        x2="36.5"
        y1="35.527"
        y2="35.527"
        fill="none"
        stroke="#1f212b"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
      ></line>
      <line
        x1="28.5"
        x2="18"
        y1="35.527"
        y2="35.527"
        fill="none"
        stroke="#1f212b"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
      ></line>
      <line
        x1="33.5"
        x2="32.5"
        y1="35.527"
        y2="35.527"
        fill="none"
        stroke="#1f212b"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
      ></line>
      <path
        fill="#fefdef"
        d="M41.322,29.04c0-0.167,0.038-0.282,0.114-0.348c0.076-0.065,0.19-0.097,0.342-0.097 c0.304,0,0.456,0.105,0.456,0.315c0,0.383,0.125,0.694,0.375,0.933c0.25,0.239,0.599,0.358,1.047,0.358 c0.955,0,1.433-0.513,1.433-1.542v-4.808h-1.411c-0.102,0-0.179-0.039-0.234-0.119c-0.054-0.079-0.081-0.18-0.081-0.303 c0-0.268,0.105-0.402,0.315-0.402h1.91c0.108,0,0.204,0.029,0.287,0.087C45.958,23.172,46,23.252,46,23.353v5.307 c0,0.819-0.212,1.417-0.635,1.797c-0.423,0.379-0.982,0.57-1.677,0.57c-0.709,0-1.281-0.183-1.715-0.549 C41.539,30.113,41.322,29.634,41.322,29.04z"
      ></path>
      <path
        fill="#fefdef"
        d="M48.007,28.66v-5.318c0-0.102,0.045-0.179,0.136-0.234c0.09-0.054,0.197-0.081,0.32-0.081 c0.123,0,0.23,0.027,0.32,0.081c0.09,0.055,0.135,0.132,0.135,0.234v5.318c0,1.029,0.485,1.542,1.455,1.542 c0.47,0,0.832-0.128,1.085-0.385c0.253-0.257,0.38-0.642,0.38-1.157v-5.318c0-0.21,0.152-0.315,0.456-0.315 c0.123,0,0.23,0.027,0.32,0.081c0.091,0.055,0.136,0.132,0.136,0.234v5.318c0,0.819-0.217,1.417-0.651,1.797 c-0.434,0.379-1.009,0.57-1.726,0.57c-0.717,0-1.29-0.191-1.72-0.57C48.222,30.077,48.007,29.479,48.007,28.66z"
      ></path>
      <path
        fill="#fefdef"
        d="M55,30.636v-7.294c0-0.102,0.045-0.179,0.135-0.234c0.091-0.054,0.197-0.081,0.32-0.081 c0.123,0,0.23,0.027,0.32,0.081c0.091,0.055,0.136,0.132,0.136,0.234v6.794h2.963c0.094,0,0.167,0.042,0.217,0.125 c0.051,0.083,0.076,0.179,0.076,0.288c0,0.108-0.026,0.204-0.076,0.287c-0.051,0.084-0.123,0.125-0.217,0.125h-3.463 c-0.108,0-0.205-0.029-0.287-0.087C55.041,30.817,55,30.737,55,30.636z"
      ></path>
      <g>
        <path
          fill="#1f212b"
          d="M37.771,48.524c0-0.29,0.158-0.633,0.475-1.03l2.932-4.833c0.238-0.422,0.555-0.634,0.951-0.634 c0.58,0,0.871,0.278,0.871,0.832v27.257c0,0.581-0.331,0.871-0.99,0.871c-0.661,0-0.99-0.29-0.99-0.871V46.069l-1.664,2.853 c-0.159,0.344-0.396,0.515-0.713,0.515c-0.238,0-0.442-0.093-0.614-0.278C37.856,48.974,37.771,48.762,37.771,48.524z"
        ></path>
        <path
          fill="#1f212b"
          d="M48.034,48.802v-5.903c0-0.211,0.099-0.409,0.297-0.594c0.198-0.185,0.416-0.278,0.653-0.278h14.064 c0.211,0,0.423,0.093,0.634,0.278C63.894,42.49,64,42.688,64,42.899v3.09c0,0.238-0.08,0.475-0.239,0.713L51.521,70.552 c-0.18,0.317-0.412,0.475-0.695,0.475c-0.312,0-0.584-0.085-0.817-0.257c-0.234-0.171-0.35-0.389-0.35-0.653 c0-0.079,0.052-0.251,0.158-0.515l12.202-23.652v-2.02H50.015v4.873c0,0.237-0.099,0.442-0.297,0.614 c-0.198,0.172-0.429,0.257-0.693,0.257c-0.264,0-0.495-0.085-0.693-0.257C48.133,49.245,48.034,49.039,48.034,48.802z"
        ></path>
      </g>
    </svg>
  );
}

export function GoogleCalendarIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 20 20" fill="none">
      <path
        d="M11.088 9.40801L11.452 9.92601L12.012 9.52001V12.46H12.614V8.59601H12.11L11.088 9.40801Z"
        fill="#1E88E5"
      />
      <path
        d="M10.122 10.416C10.346 10.22 10.486 9.926 10.486 9.618C10.486 9.002 9.94001 8.498 9.28201 8.498C8.72201 8.498 8.23201 8.848 8.10601 9.366L8.69401 9.52C8.75001 9.282 9.00201 9.114 9.28201 9.114C9.61801 9.114 9.88401 9.338 9.88401 9.618C9.88401 9.898 9.61801 10.122 9.28201 10.122H8.93201V10.738H9.28201C9.66001 10.738 9.98201 11.004 9.98201 11.312C9.98201 11.634 9.67401 11.886 9.29601 11.886C8.96001 11.886 8.66601 11.676 8.62401 11.382L8.03601 11.48C8.13401 12.054 8.68001 12.488 9.31001 12.488C10.024 12.488 10.598 11.956 10.598 11.298C10.584 10.948 10.402 10.626 10.122 10.416Z"
        fill="#1E88E5"
      />
      <path d="M14.028 16.842H6.97202V14.028H14.028V16.842Z" fill="#FBC02D" />
      <path d="M16.842 14.028V6.972H14.028V14.028H16.842Z" fill="#4CAF50" />
      <path
        d="M14.028 6.972V4.158H5.20801C4.62001 4.158 4.14401 4.634 4.14401 5.222V14.042H6.95801V6.972H14.028Z"
        fill="#1E88E5"
      />
      <path d="M14.028 14.028V16.842L16.842 14.028H14.028Z" fill="#E53935" />
      <path
        d="M15.792 4.158H14.028V6.972H16.842V5.208C16.842 4.62 16.38 4.158 15.792 4.158Z"
        fill="#1565C0"
      />
      <path
        d="M5.20802 16.842H6.97202V14.028H4.15802V15.792C4.15802 16.38 4.62002 16.842 5.20802 16.842Z"
        fill="#1565C0"
      />
    </svg>
  );
}

export function DesktopDownloadIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
      <path
        d="M19.2227 6.69531L16.3047 3.74219C15.9883 3.42578 15.5312 3.25 15.1094 3.25H7.9375C6.98828 3.25 6.25 4.02344 6.25 4.9375V19.5625C6.25 20.5117 6.98828 21.25 7.9375 21.25H18.0625C18.9766 21.25 19.75 20.5117 19.75 19.5625V7.89062C19.75 7.46875 19.5391 7.01172 19.2227 6.69531ZM18.4492 7.50391C18.5195 7.57422 18.5547 7.67969 18.5898 7.75H15.25V4.41016C15.3203 4.44531 15.4258 4.48047 15.4961 4.55078L18.4492 7.50391ZM18.0625 20.125H7.9375C7.62109 20.125 7.375 19.8789 7.375 19.5625V4.9375C7.375 4.65625 7.62109 4.375 7.9375 4.375H14.125V8.03125C14.125 8.52344 14.4766 8.875 14.9688 8.875H18.625V19.5625C18.625 19.8789 18.3438 20.125 18.0625 20.125ZM17.2891 14.1133C16.7969 13.6562 15.3555 13.7969 14.6875 13.9023C13.9492 13.4453 13.457 12.8125 13.1055 11.8984C13.2461 11.2656 13.5273 10.2461 13.3164 9.61328C13.1758 8.62891 11.9102 8.73438 11.7695 9.36719C11.5938 10.0352 11.7344 10.9492 12.0508 12.1094C11.6289 13.0938 10.9961 14.4648 10.5742 15.2383C9.83594 15.5898 8.67578 16.2578 8.5 17.0664C8.39453 17.6641 9.30859 18.4375 10.3633 17.2773C10.6797 16.9609 11.0312 16.4336 11.4531 15.6953C12.4023 15.3789 13.457 14.9922 14.3359 14.8516C15.1094 15.2734 16.0234 15.5547 16.6211 15.5547C17.6055 15.5547 17.6406 14.5 17.2891 14.1133ZM9.20312 17.2422C9.41406 16.6797 10.2227 16.0469 10.4688 15.8008C9.69531 17.0664 9.20312 17.2773 9.20312 17.2422ZM12.5781 9.4375C12.8594 9.4375 12.8242 10.7383 12.6484 11.125C12.4375 10.5273 12.4727 9.4375 12.5781 9.4375ZM11.5586 15.0273C11.9453 14.3242 12.2969 13.5156 12.5781 12.8125C12.9297 13.4102 13.3516 13.9023 13.8086 14.2539C12.9648 14.4297 12.2266 14.7812 11.5586 15.0273ZM16.9727 14.8164C16.9727 14.8164 16.7617 15.0625 15.4258 14.5C16.8672 14.3945 17.1133 14.7461 16.9727 14.8164Z"
        fill="#292B29"
      />
    </svg>
  );
}

export function MenuIcon() {
  return (
    <svg className="h-full" viewBox="0 0 31 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.89648 12H29.4827"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.89648 22H29.4827"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.89648 2.35718H29.4827"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function OetkerLogoIcon() {
  return (
    <svg className="h-full" xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 550 350">
      <path
        d="M275 0C394.7 0 435.1 32.6 466.2 48.5c28.2 14.4 59.4 29.6 62.1 70.8 3 45.1 1.1 92.1-11.4 111.4 -11.1 17.2-25.3 42.4-95.6 77 -70.2 34.6-146.6 33.4-146.4 33.2 0.2 0.2-76.1 1.4-146.4-33.2 -70.2-34.6-84.5-59.8-95.6-77 -12.4-19.3-14.4-66.3-11.4-111.4 2.8-41.2 34-56.4 62.2-70.8C114.9 32.6 155.3 0 275 0z"
        fill="#FFFFFF"
      />
      <path
        d="M275 9c83.4 0 160.1 23.6 191.2 39.5 28.2 14.4 59.4 29.6 62.1 70.8 3 45.1 1.1 92.1-11.4 111.4 -11.1 17.2-25.3 42.4-95.6 77 -70.2 34.6-146.6 33.4-146.4 33.2 0.2 0.2-76.1 1.4-146.4-33.2 -70.2-34.6-84.5-59.8-95.6-77 -12.4-19.3-14.4-66.3-11.4-111.4 2.8-41.2 34-56.4 62.2-70.8C114.9 32.6 191.6 9 275 9"
        fill="#E30A17"
      />
      <path
        d="M441.6 239.4c44.5-21.3 50.2-37 54.6-44.7 4.8-8.5 6.8-36.3 5.3-55.8 -1.3-17.2-3.9-28.6-27.7-39.4C449.2 88.5 358.5 75.3 275 75.3c-83.4 0-174.2 13.3-198.8 24.3 -23.8 10.7-26.4 22.2-27.7 39.4 -1.4 19.4 0.5 47.3 5.4 55.8 4.4 7.6 10 23.4 54.6 44.7 27.6 13.2 56 20.1 75.4 23.8 0.9 0.2 1.5 0.9 1.5 1.8v0.2l0 1.6c0 33.3 40.2 60.3 89.7 60.4 49.6-0.1 89.7-27.1 89.7-60.4l0-1.7v-0.1c0-0.9 0.7-1.7 1.6-1.9C385.7 259.5 414 252.6 441.6 239.4"
        fill="#FFFFFF"
      />
      <path
        d="M217.8 114.5c-21.2 0-29.4 15.4-30.8 35.6 -0.2 2.2-0.2 4.5-0.2 6.8 0 6.4 0.6 12.4 1.8 17.8h17.9c-1-5-1.1-11.1-1.1-17.8 0-2.4 0-4.6 0.1-6.8 0.5-13.2 2.8-23 12.3-23 8.8 0 11.7 9.8 12.3 23 0.1 2.2 0.1 4.5 0.1 6.8 0 6.7-0.4 12.8-1.5 17.8 -1.6 7.3-4.9 12.1-11 12.1 -6.8 0-9.9-4.7-11.3-12.1l-17.9 0c3.4 14.5 12 24.5 29.2 24.5 17 0 25.7-10 29.2-24.5 0 0 0 0 0 0 1.3-5.4 1.9-11.4 1.9-17.8 0-2.3-0.1-4.6-0.3-6.8C247.2 129.9 238.9 114.5 217.8 114.5zM345.9 116.4v33.7 24.6 22.4h16v-18.2l3.2-4.2 2.5-3.2 1.7 3.2 11.6 22.4h17.6l-12.2-22.4 -8.4-15.3 6.8-9.3 11.2-15.3h-17.6l-10.7 15.3 -5.6 8v-8 -33.7H345.9zM75.5 116.8v33.3 24.6 22.4h27.8c17.4 0 25.5-7.1 28.5-22.4h-18.7c-1.9 6.1-5.6 8.5-12.7 8.5h-7.7v-8.5 -24.6 -20.3h7.3c11.6 0 14.2 6.9 14.7 20.3h18.4c-0.8-20.4-6.3-33.3-28.8-33.3H75.5zM133.2 150.1l-18.4 0c0.1 1.8 0.1 3.7 0.1 5.7 0 8.5-0.4 14.6-1.7 18.8l18.7 0c1-5.3 1.5-11.5 1.5-18.8C133.3 153.9 133.3 152 133.2 150.1zM316 121.8v12.3h-8.1v10.9h8.1v5.1 24.6 5.9c0 12.6 2.3 16.5 14.8 16.5 3.7 0 6.9-0.4 10.4-0.7V185.3c-1.1 0.1-2.3 0.2-3.6 0.2 -4.6 0-5.7-2-5.7-6.8v-4 -24.6 -5.1h9.3v-10.9h-9.3v-12.3H316zM280.1 131.3c-4.1 0-7.8 0.8-11.2 2.4 -3.3 1.6-6.2 3.9-8.6 6.9 -2.1 2.6-3.8 5.8-5 9.5 -0.2 0.5-0.3 1.1-0.5 1.6 -1.3 4.3-1.9 9-1.9 14.2 0 3.1 0.2 6 0.7 8.8 0.6 3.3 1.4 6.2 2.6 8.9 2.2 5 5.4 8.8 9.6 11.6 4.2 2.7 9.1 4.1 14.8 4.1 4.9 0 9.2-0.9 13-2.8 3.8-1.9 6.8-4.5 9.1-7.9 2.4-3.4 3.8-7.3 4.2-11.7h-16.8c-0.7 2.8-1.9 5-3.7 6.6 -1.8 1.6-3.8 2.4-6.2 2.4 -3.2 0-5.8-1.4-7.8-4.1 -1.4-1.9-2.3-4.2-2.8-7 -0.2-1.2-0.3-2.5-0.3-3.8v-0.7h38.1v-2.6c0-6-0.6-11.2-1.7-15.5 -0.2-0.7-0.4-1.3-0.6-2 0 0 0 0 0 0 -1.1-3.5-2.8-6.6-4.8-9.4 -1.5-2-3.3-3.7-5.5-5.1 -2.1-1.4-4.5-2.5-7-3.2C285.4 131.7 282.8 131.3 280.1 131.3zM422.1 131.3c-4.1 0-7.9 0.8-11.2 2.4 -3.3 1.6-6.1 3.9-8.6 6.9 -2.1 2.6-3.8 5.8-5 9.5 -0.2 0.5-0.3 1.1-0.5 1.6 -1.3 4.3-1.9 9-1.9 14.2 0 3.1 0.2 6 0.7 8.8 0.5 3.3 1.4 6.2 2.6 8.9 2.2 5 5.4 8.8 9.5 11.6 4.2 2.7 9.2 4.1 14.8 4.1 4.9 0 9.2-0.9 13-2.8 3.8-1.9 6.9-4.5 9.2-7.9 2.4-3.4 3.7-7.3 4.1-11.7h-16.7c-0.7 2.8-1.9 5-3.7 6.6 -1.8 1.6-3.9 2.4-6.2 2.4 -3.2 0-5.8-1.4-7.8-4.1 -1.4-1.9-2.4-4.2-2.8-7 -0.2-1.2-0.3-2.5-0.3-3.8v-0.7h38.1v-2.6c0-6-0.6-11.2-1.7-15.5 -0.2-0.7-0.4-1.3-0.6-2 0 0 0 0 0 0 -1.1-3.5-2.8-6.6-4.9-9.4 -1.5-2-3.3-3.7-5.5-5.1 -2.1-1.4-4.5-2.5-7-3.2C427.4 131.7 424.8 131.3 422.1 131.3zM169.9 133.2c-6.6 0-11.1 3.9-14.3 9.9h-0.3v-8.3h-15.3v15.3l21.1 0c2-1.1 4.4-1.6 6.7-1.6 1.6 0 3.3 0.1 5 0.2v-15.3C171.9 133.3 170.8 133.2 169.9 133.2zM140 150.1v24.6 22.4h16v-22.4 -15c0-4.9 2.2-8 5.2-9.6H140zM484.9 133.2c-6.6 0-11.1 3.9-14.3 9.9h-0.3v-8.3H455v15.3l21.1 0c2-1.1 4.4-1.6 6.7-1.6 1.6 0 3.3 0.1 5 0.2v-15.3C486.8 133.3 485.8 133.2 484.9 133.2zM455 150.1v24.6 22.4h16v-22.4 -15c0-4.9 2.2-8 5.1-9.6H455zM280.3 144.2c2.9 0 5.2 1.1 6.8 3.3 0.6 0.7 1.1 1.6 1.5 2.6 0.9 2 1.5 4.4 1.9 7.4H269.5c0.3-2.9 1-5.4 2-7.4 0.4-0.9 1-1.7 1.6-2.5C274.9 145.3 277.4 144.2 280.3 144.2zM422.3 144.2c2.9 0 5.2 1.1 6.8 3.3 0.6 0.7 1.1 1.6 1.5 2.6 0.9 2 1.5 4.4 1.9 7.4h-21c0.3-2.9 0.9-5.4 1.9-7.4 0.4-0.9 1-1.7 1.6-2.5C417 145.3 419.4 144.2 422.3 144.2zM161.4 183.4v13.7h13.7V183.4H161.4z"
        fill="#25338B"
      />
      <path
        d="M273.7 218.9c-1.4 0.1-3 0.4-4 0.2 -0.9-0.1-1.9 0-2.8-0.2 -0.7-0.1-1.4-0.1-2.1 0.1 -1.1 0.1-2 0.5-2.8 1 -0.8 0.6-3 3.5-3.5 3.9 -0.4 0.4-1.9 1.6-2.6 2.3 -0.8 0.8-1.5 2.5-1.7 3.4 -0.1 0.9-0.1 2.7 0 3.2 0.1 0.4 0 1.1-0.1 1.6 -0.1 0.5-0.5 2.2-0.6 2.4 -0.2 0.2-0.3 1.4-0.3 3.1 0 1.7 0.1 2.7-0.1 3.8 -0.2 1.1-0.3 2.3-2.4 4.6 -2.1 2.3-2 2.7-2.2 3.2 -0.2 0.5-0.3 0.9 0.2 1.7 0.6 0.8 0.9 0.8 1.4 1.2 0.4 0.4 2 0.7 1.5 2.5 -0.6 1.9 0.5 2 0.5 2.7 0 0.7-0.2 0.9-0.1 1.5 0.1 0.6 0.6 1.4 0.6 1.9 0 0.9 0.1 1.5-0.2 3.8 0 0-0.3 2.8 3.6 3.8 3.9 1 6.6 2.2 7.5 3.6 0.9 1.4 1 3.3 0.5 5 -0.5 1.7-1.6 3.5-4.3 5.3 -2.8 2-7.6 3.6-13.4 6.8 -5.8 3.2-6.8 4.8-7.7 6 -0.7 0.9-1.7 2.8-1.9 4 -0.1 1-0.4 2.6 1.4 3.4 2 0.9 3.3 0.6 3.3 0.6h69.4c0 0 2.9 0.4 4.4-1.4 1.5-1.9 0.2-5.5-0.1-6.3 -0.4-1-1.9-2.8-3.4-4 -1.6-1.4-6.8-4.6-9.6-6.1 -2.3-1.2-9.9-5.5-12.9-9.1 -2.7-3.2-3.8-7.1-3-9.3 0.9-2.2 2.6-2.4 3.8-2.3 1 0.1 3.6 0.7 4.6 0.5 1.2-0.3 2.3-0.7 3.4-2.6 1.1-1.9 4.2-2.5 4.9-3 0.7-0.4 4.1-2.6 4.3-5.9 0.3-4.4-1.4-4.4-2-9 -0.5-4.6-1.4-5.3-3.1-7.3 -1.4-1.6-2.5-5.2-3.1-6.6 -1.1-2.7-3.5-4.2-4.6-4.5 -1.1-0.3-4.3-1.8-5.7-3.4 -1.2-1.3-3.2-3.3-5-3.7 -1.7-0.4-4.8-0.5-5.8-1 -1.1-0.6-2.9-1.2-3.2-1.1C274.5 219.1 275.1 218.9 273.7 218.9M191.5 266.6c0-30.3 37.4-54.8 83.6-54.8 46.2 0 83.6 24.6 83.6 54.8 0 30.3-37.4 54.8-83.6 54.8C228.9 321.4 191.5 296.9 191.5 266.6z"
        fill="#E30A17"
      />
    </svg>
  );
}
export function CameoLogoIcon() {
  return (
    <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 188.74 124.21">
      <defs></defs>
      <g id="surface1">
        <path
          fill="#fff"
          d="M168.87,16.65c16.02,8.05,19.59,16.68,19.59,36.35,0,24.74-5.22,32.71-14.2,41.13-14.11,13.22-41.63,29.79-79.72,29.79S28.59,107.35,14.48,94.13C5.49,85.71,.28,77.74,.28,53,.28,33.33,3.85,24.7,19.86,16.65,39.26,6.91,64.95,.28,94.19,.28s55.28,6.63,74.68,16.37"
        />
        <path
          fill="#ed1c24"
          d="M94.19,.06c29.28,0,55.35,6.64,74.78,16.4,16.12,8.1,19.7,16.82,19.7,36.55,0,24.79-5.23,32.83-14.27,41.3-14.14,13.25-41.72,29.85-79.87,29.85S28.47,107.54,14.33,94.3C5.29,85.83,.06,77.79,.06,53,.06,33.28,3.65,24.55,19.77,16.45,39.2,6.7,64.92,.06,94.19,.06"
        />
        <path
          fill="#ed1c24"
          d="M94.19,.11c-14.04,0-27.8,1.53-40.89,4.54-12.13,2.79-23.4,6.78-33.51,11.85-8.14,4.09-13.04,8.37-15.88,13.89C1.22,35.64,.11,42.19,.11,53c0,11.79,1.19,20.29,3.74,26.75,2.43,6.14,5.96,10.23,10.51,14.5,8.3,7.78,19.34,14.84,31.08,19.89,15.37,6.6,31.89,9.95,49.09,9.95s33.64-3.35,48.92-9.95c14.88-6.43,25.02-14.37,30.92-19.89,4.55-4.26,8.08-8.36,10.51-14.5,2.55-6.46,3.74-14.96,3.74-26.75,0-10.81-1.1-17.36-3.8-22.61-2.84-5.52-7.74-9.8-15.88-13.89C147.9,5.93,121.35,.11,94.19,.11m.34,124.09c-17.22,0-33.75-3.35-49.13-9.96-11.76-5.05-22.8-12.12-31.12-19.91-4.56-4.28-8.1-8.38-10.54-14.55-2.56-6.47-3.75-14.98-3.75-26.79,0-10.82,1.11-17.39,3.82-22.66,2.85-5.54,7.76-9.84,15.92-13.94,10.12-5.08,21.4-9.07,33.54-11.86C66.38,1.53,80.14,0,94.19,0c27.18,0,53.74,5.83,74.8,16.4,8.16,4.1,13.07,8.4,15.93,13.94,2.71,5.27,3.82,11.83,3.82,22.66,0,11.81-1.2,20.32-3.75,26.79-2.44,6.16-5.98,10.27-10.54,14.55-5.9,5.53-16.06,13.47-30.94,19.91-15.29,6.61-31.77,9.96-48.97,9.96"
        />
        <path
          fill="#fff"
          d="M94.18,24.79c20.05-.26,54.16,1.75,71.23,7.92,10.74,3.75,13.02,8.79,12.79,21.97-.16,9.13-.61,16.16-8.08,22.11-18.45,14.69-43.57,20.78-75.62,20.78s-57.42-6.1-75.87-20.78c-7.47-5.95-7.93-12.97-8.08-22.11-.23-13.18,2.04-18.22,12.79-21.97,17.08-6.17,50.81-8.18,70.85-7.92"
        />
        <path
          fill="#fff"
          d="M90.66,24.82c-22.56,0-52.13,2.46-67.32,7.94-5.51,1.93-8.65,4.15-10.48,7.43-1.74,3.12-2.4,7.31-2.27,14.49,.17,9.58,.82,16.3,8.07,22.06,9.1,7.25,19.83,12.45,32.81,15.89,12.38,3.28,26.45,4.88,43.02,4.88s30.58-1.6,42.9-4.88c12.88-3.44,23.57-8.63,32.69-15.89,7.24-5.77,7.9-12.48,8.06-22.06,.13-7.17-.53-11.37-2.27-14.49-1.83-3.28-4.96-5.5-10.48-7.43-15.19-5.48-44.94-7.94-67.69-7.94-1.2,0-2.39,.01-3.53,.02-1.13-.01-2.32-.02-3.52-.02m3.83,72.8c-16.58,0-30.67-1.6-43.05-4.88-12.99-3.45-23.74-8.66-32.85-15.91-7.29-5.8-7.94-12.54-8.11-22.15-.13-7.19,.53-11.41,2.28-14.55,1.85-3.3,5-5.54,10.54-7.48,15.2-5.48,44.78-7.94,67.35-7.94,1.2,0,2.39,0,3.52,.02,1.13-.02,2.32-.02,3.53-.02,22.76,0,52.53,2.46,67.73,7.94,5.55,1.94,8.7,4.18,10.54,7.48,1.75,3.14,2.41,7.35,2.29,14.55-.17,9.62-.83,16.35-8.11,22.15-9.12,7.26-19.83,12.47-32.73,15.91-12.32,3.28-26.37,4.88-42.93,4.88"
        />
        <path
          fill="#fff"
          d="M93.83,73.37c18.02,0,33.13,8.78,33.13,22.72s-15.61,23.07-33.13,23.07c-18.88,0-33.29-9.58-33.29-22.9s15.89-22.9,33.29-22.9"
        />
        <path
          fill="#ed1c24"
          d="M62.7,96.27c0-11.7,14.02-20.74,31.13-20.74s30.97,8.55,30.97,20.56-13.78,20.91-30.97,20.91c-18.5,0-31.13-9.28-31.13-20.73"
        />
        <path
          fill="#fff"
          d="M106.79,110.67c.95,0,2-.3,1.98-1.41-.02-.99-.33-2.12-2.87-3.89-3.18-2.21-8.54-4.14-8.16-7.93,.09-.93,.66-1.28,1.5-1.35,.84-.08,1.07,.25,1.82,.17,.88-.1,.98-1.29,2.02-1.66,1.18-.42,2.77-1.43,2.58-3.13-.1-.91-.53-1.61-.68-2.3-.2-.87,0-1.56-.46-2.23s-1.11-1.44-1.41-2.28c-.3-.84-.49-1.8-1.18-2.3-.93-.66-1.52-.66-2.13-1.07-.78-.51-1.47-1.7-2.57-2.02-.6-.17-1-.09-1.66-.26-.79-.21-1.49-.58-2.16-.6-.93-.01-1.96,.04-2.81-.06-1.52-.17-2.08,1.15-2.71,1.81-.36,.38-.95,.78-1.22,1.08-.88,1.03-.31,2.32-.61,3.11-.48,1.27-.19,2.69-.45,3.66-.25,.89-1.67,2.09-1.7,2.63-.04,.71,.96,.88,1.14,1.53,.2,.7-.18,.85,.26,1.32,.13,.15-.28,.29,.03,.86,.52,.97-.22,1.77,.28,2.59,.48,.81,4.35,.64,4.35,3.19s-2.87,3.64-4.99,4.58c-3.74,1.64-5.15,3.22-5.42,4.73-.17,.99,.52,1.22,1.49,1.22h25.75"
        />
        <path
          fill="#2744a0"
          d="M43.93,52.69h-7.78s-.95-5-5.89-5.06c-4.95-.05-6.46,5.24-6.46,7.88,0,2.28,.23,8.74,6.42,8.74,4.36,0,5.68-3.82,6.04-5.14h7.83s-1.11,10.66-14.14,10.66c-10.32,0-14.03-6.8-14.03-14.15,0-6.8,4.74-13.52,14.38-13.52,10.98,0,13.77,8.22,13.64,10.59"
        />
        <path
          fill="#2744a0"
          d="M64.21,56.94c-1.71,.54-4.79,1.28-7.47,1.65-2.9,.39-3.78,1.62-3.73,2.82,0,1.94,2.44,3.22,5.11,3.08,3.22-.16,6.09-1.76,6.09-4.63v-2.92Zm-9.56-5.88h-7.83c0-3.75,3.71-8.75,12.47-8.75s12.6,4.38,12.6,9.35v17.68l-6.94-.06-.56-1.81c-3.8,4.14-19.4,3.88-19.4-5.73,0-7.42,7.02-7.88,14.99-9.04,2.67-.39,3.95-1.14,4.01-2.29,.07-1.25-1.34-2.9-4.47-2.9-3.9,0-4.88,3.55-4.88,3.55"
        />
        <path
          fill="#2744a0"
          d="M90.46,52.64c0-1.89-1.56-3.92-3.81-3.92-2.85,0-4.15,2.2-4.15,3.92v16.73h-7.61v-25.74h7.03l.61,1.93c.8-1.03,3.31-2.62,6.63-2.62s5.7,1.25,7.36,3.3c1.77-2,4.59-3.19,7.25-3.19,4.87,0,9.58,2.48,9.58,9.09l.02,17.23h-7.58l-.02-16.98c0-2-1.65-3.68-3.86-3.68-2.45,0-3.86,2.02-3.86,3.62l.04,17.03h-7.61v-16.73"
        />
        <path
          fill="#2744a0"
          d="M123.92,53.46h10.55s-.67-5.13-5.23-5.13c-4.8,0-5.32,5.13-5.32,5.13m18.68,5.32h-18.85s.04,6.08,5.59,6.08c3.71,0,4.55-2.98,4.55-2.98h7.95s-1.26,8.5-12.83,8.5c-8.3,0-13.61-5.85-13.61-13.38,0-9.4,7.1-14.06,13.73-14.06s14.25,4.73,13.47,15.84"
        />
        <path
          fill="#2744a0"
          d="M158.45,48.6c-2.58,0-6.33,1.76-6.33,8.25s3.7,8.22,6.33,8.22,6.33-1.74,6.33-8.22-3.74-8.25-6.32-8.25m0-5.56c6.24,0,14.19,3.58,14.19,13.85s-7.86,13.8-14.19,13.8-14.19-3.55-14.19-13.8,7.96-13.85,14.2-13.85"
        />
      </g>
    </svg>
  );
}

export function LeftArrowIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 22 13" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M7.375 11.8594L7.75 11.5312C7.9375 11.2969 7.9375 10.9688 7.75 10.7344L3.8125 6.79688H21.4375C21.7188 6.79688 22 6.5625 22 6.23438V5.76562C22 5.48438 21.7188 5.20312 21.4375 5.20312H3.8125L7.75 1.3125C7.9375 1.07812 7.9375 0.75 7.75 0.515625L7.375 0.1875C7.1875 -0.046875 6.8125 -0.046875 6.625 0.1875L1.14062 5.625C0.90625 5.85938 0.90625 6.1875 1.14062 6.42188L6.625 11.8594C6.8125 12.0938 7.1875 12.0938 7.375 11.8594Z"
        fill="#292B29"
      />
    </svg>
  );
}

export function RightArrowIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5781 6.1875L16.2031 6.51562C16.0156 6.75 16.0156 7.07812 16.2031 7.3125L20.1406 11.2031H2.5625C2.23438 11.2031 2 11.4844 2 11.7656V12.2344C2 12.5625 2.23438 12.7969 2.5625 12.7969H20.1406L16.2031 16.7344C16.0156 16.9688 16.0156 17.2969 16.2031 17.5312L16.5781 17.8594C16.7656 18.0938 17.1406 18.0938 17.375 17.8594L22.8125 12.4219C23.0469 12.1875 23.0469 11.8594 22.8125 11.625L17.375 6.1875C17.1406 5.95312 16.7656 5.95312 16.5781 6.1875Z"
        fill="#010E54"
      />
      <path
        d="M16.5781 6.1875L16.2031 6.51562C16.0156 6.75 16.0156 7.07812 16.2031 7.3125L20.1406 11.2031H2.5625C2.23438 11.2031 2 11.4844 2 11.7656V12.2344C2 12.5625 2.23438 12.7969 2.5625 12.7969H20.1406L16.2031 16.7344C16.0156 16.9688 16.0156 17.2969 16.2031 17.5312L16.5781 17.8594C16.7656 18.0938 17.1406 18.0938 17.375 17.8594L22.8125 12.4219C23.0469 12.1875 23.0469 11.8594 22.8125 11.625L17.375 6.1875C17.1406 5.95312 16.7656 5.95312 16.5781 6.1875Z"
        fill="#292B29"
      />
    </svg>
  );
}

export function ChevronRight({ className }: { className?: string }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16.5781 6.1875L16.2031 6.51562C16.0156 6.75 16.0156 7.07812 16.2031 7.3125L20.1406 11.2031H2.5625C2.23438 11.2031 2 11.4844 2 11.7656V12.2344C2 12.5625 2.23438 12.7969 2.5625 12.7969H20.1406L16.2031 16.7344C16.0156 16.9688 16.0156 17.2969 16.2031 17.5312L16.5781 17.8594C16.7656 18.0938 17.1406 18.0938 17.375 17.8594L22.8125 12.4219C23.0469 12.1875 23.0469 11.8594 22.8125 11.625L17.375 6.1875C17.1406 5.95312 16.7656 5.95312 16.5781 6.1875Z"
        fill="#292B29"
      />
    </svg>
  );
}

export function SearchIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        fill="#252525"
        d="M23.38 21.62l-6.52-6.53a9.28 9.28 0 10-1.77 1.77l6.53 6.53a1.27 1.27 0 001.76 0 1.25 1.25 0 000-1.77zM2.75 9.5a6.75 6.75 0 1113.5 0 6.75 6.75 0 01-13.5 0z"
      />
    </svg>
  );
}

export function CurveDesktop({
  className,
  color = '#010e54',
}: {
  className?: string;
  color?: string;
}) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 150.19">
      <defs>
        <style />
      </defs>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            fill={color}
            d="M1440,80.19s-445.24,70-719.12,70C419.59,150.19,0,80.19,0,80.19V0H1440Z"
          />
        </g>
      </g>
    </svg>
  );
}

export function CurveMobile({ className }: { className?: string }) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 33.04">
      <defs>
        <style />
      </defs>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            fill="#010e54"
            d="M320,12.15S234.16,32.75,160.08,33C83.73,33.33,0,12.15,0,12.15V0H320Z"
          />
        </g>
      </g>
    </svg>
  );
}

export function ChefHat({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      id="chefhat"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
    >
      <defs></defs>
      <path
        fill="#1c1e51"
        d="M13,1a3.67,3.67,0,0,0-1.81.62A4,4,0,0,0,8,0,4.11,4.11,0,0,0,4.8,1.62,3.39,3.39,0,0,0,3,1,3,3,0,0,0,0,4H0c0,1.31,2,7,2,7v4a1,1,0,0,0,1,1H13a1,1,0,0,0,1-1V11s2-5.69,2-7A3,3,0,0,0,13,1ZM3.52,14.5V12h9v2.5Zm9.05-4h-.91L12,6.31v0A.28.28,0,0,0,11.76,6l-.5,0h0a.21.21,0,0,0-.22.22l-.34,4.31H8.48V6.25A.26.26,0,0,0,8.23,6h-.5a.24.24,0,0,0-.24.25V10.5H5.33L5,6.22A.22.22,0,0,0,4.74,6l-.5,0A.28.28,0,0,0,4,6.28v0l.35,4.19H3.43A43.84,43.84,0,0,1,1.53,4h0A1.49,1.49,0,0,1,3,2.53a1.91,1.91,0,0,1,.91.28l1.22.94L6,2.53a2.42,2.42,0,0,1,4,0l.91,1.22,1.21-.94A1.91,1.91,0,0,1,13,2.53,1.49,1.49,0,0,1,14.5,4,45.15,45.15,0,0,1,12.57,10.5Z"
      />
    </svg>
  );
}

export function CorpAccordionNumberIcon({ className }: { className?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
      <defs></defs>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <rect fill="#f4f4f4" width="40" height="40" rx="19.5" />
          <rect
            fill="none"
            stroke="#1c1e51"
            strokeMiterlimit="10"
            x="6"
            y="5.97"
            width="28"
            height="28"
            rx="14"
          />
        </g>
      </g>
    </svg>
  );
}

export function PDFIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
      <path
        d="M19.2227 6.69531L16.3047 3.74219C15.9883 3.42578 15.5312 3.25 15.1094 3.25H7.9375C6.98828 3.25 6.25 4.02344 6.25 4.9375V19.5625C6.25 20.5117 6.98828 21.25 7.9375 21.25H18.0625C18.9766 21.25 19.75 20.5117 19.75 19.5625V7.89062C19.75 7.46875 19.5391 7.01172 19.2227 6.69531ZM18.4492 7.50391C18.5195 7.57422 18.5547 7.67969 18.5898 7.75H15.25V4.41016C15.3203 4.44531 15.4258 4.48047 15.4961 4.55078L18.4492 7.50391ZM18.0625 20.125H7.9375C7.62109 20.125 7.375 19.8789 7.375 19.5625V4.9375C7.375 4.65625 7.62109 4.375 7.9375 4.375H14.125V8.03125C14.125 8.52344 14.4766 8.875 14.9688 8.875H18.625V19.5625C18.625 19.8789 18.3438 20.125 18.0625 20.125ZM17.2891 14.1133C16.7969 13.6562 15.3555 13.7969 14.6875 13.9023C13.9492 13.4453 13.457 12.8125 13.1055 11.8984C13.2461 11.2656 13.5273 10.2461 13.3164 9.61328C13.1758 8.62891 11.9102 8.73438 11.7695 9.36719C11.5938 10.0352 11.7344 10.9492 12.0508 12.1094C11.6289 13.0938 10.9961 14.4648 10.5742 15.2383C9.83594 15.5898 8.67578 16.2578 8.5 17.0664C8.39453 17.6641 9.30859 18.4375 10.3633 17.2773C10.6797 16.9609 11.0312 16.4336 11.4531 15.6953C12.4023 15.3789 13.457 14.9922 14.3359 14.8516C15.1094 15.2734 16.0234 15.5547 16.6211 15.5547C17.6055 15.5547 17.6406 14.5 17.2891 14.1133ZM9.20312 17.2422C9.41406 16.6797 10.2227 16.0469 10.4688 15.8008C9.69531 17.0664 9.20312 17.2773 9.20312 17.2422ZM12.5781 9.4375C12.8594 9.4375 12.8242 10.7383 12.6484 11.125C12.4375 10.5273 12.4727 9.4375 12.5781 9.4375ZM11.5586 15.0273C11.9453 14.3242 12.2969 13.5156 12.5781 12.8125C12.9297 13.4102 13.3516 13.9023 13.8086 14.2539C12.9648 14.4297 12.2266 14.7812 11.5586 15.0273ZM16.9727 14.8164C16.9727 14.8164 16.7617 15.0625 15.4258 14.5C16.8672 14.3945 17.1133 14.7461 16.9727 14.8164Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IMGIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.8398 15.0625L9.43359 13.6914C9.25781 13.5156 9.01172 13.5156 8.83594 13.6914L7.46484 15.0625V19H16.4648V13.9375L14.4961 12.0039C14.3203 11.8281 14.0742 11.8281 13.8984 12.0039L10.8398 15.0625ZM14.2148 13.3047L15.3398 14.4297V17.875H8.58984V15.5195L9.15234 14.9922L10.8398 16.6797C11.543 15.9414 13.5469 13.9375 14.2148 13.3047ZM9.71484 12.25C10.9453 12.25 11.9648 11.2656 11.9648 10C11.9648 8.76953 10.9453 7.75 9.71484 7.75C8.44922 7.75 7.46484 8.76953 7.46484 10C7.46484 11.2656 8.44922 12.25 9.71484 12.25ZM9.71484 8.875C10.3125 8.875 10.8398 9.40234 10.8398 10C10.8398 10.6328 10.3125 11.125 9.71484 11.125C9.08203 11.125 8.58984 10.6328 8.58984 10C8.58984 9.40234 9.08203 8.875 9.71484 8.875ZM18.2227 6.69531L15.3047 3.74219C14.9883 3.42578 14.5312 3.25 14.1094 3.25H6.9375C5.98828 3.25 5.25 4.02344 5.25 4.9375V19.5625C5.25 20.5117 5.98828 21.25 6.9375 21.25H17.0625C17.9766 21.25 18.75 20.5117 18.75 19.5625V7.89062C18.75 7.46875 18.5391 7.01172 18.2227 6.69531ZM14.25 4.41016C14.3203 4.44531 14.4258 4.48047 14.4961 4.55078L17.4492 7.50391C17.5195 7.57422 17.5547 7.67969 17.5898 7.75H14.25V4.41016ZM17.625 19.5625C17.625 19.8789 17.3438 20.125 17.0625 20.125H6.9375C6.62109 20.125 6.375 19.8789 6.375 19.5625V4.9375C6.375 4.65625 6.62109 4.375 6.9375 4.375H13.125V8.03125C13.125 8.52344 13.4766 8.875 13.9688 8.875H17.625V19.5625Z"
        fill="currentColor"
      />
    </svg>
  );
}

interface IPlayButtonProps {
  colorScheme?: string;
  className?: string;
}

export const PlayButton = ({ colorScheme, className }: IPlayButtonProps) => {
  let playColorScheme;
  switch (colorScheme) {
    case 'Black': {
      playColorScheme = {
        playButton: '#FFFFFF',
        innerCircleBackground: '#000000',
        outerCircleBackground: '#FFFFFF',
      };
      break;
    }
    case 'White': {
      playColorScheme = {
        playButton: '#000000',
        innerCircleBackground: '#FFFFFF',
        outerCircleBackground: '#000000',
      };
      break;
    }
    case 'Grey': {
      playColorScheme = {
        playButton: '#FFFFFF',
        innerCircleBackground: '#010e54',
        outerCircleBackground: '#FFFFFF',
      };
      break;
    }
    default: {
      playColorScheme = {
        playButton: '#FFFFFF',
        innerCircleBackground: '#010e54',
        outerCircleBackground: '#FFFFFF',
      };
    }
  }

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 109 108"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <title>Play</title>
      <circle
        cx="54.5"
        cy="54"
        r="54"
        transform="rotate(-90 54.5 54)"
        fill={playColorScheme.innerCircleBackground}
      />
      <path
        d="M48.5 42L64.5 54.0003L48.5 66V42Z"
        fill={playColorScheme.playButton}
        stroke={playColorScheme.playButton}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="54.5"
        cy="54"
        r="42"
        stroke={playColorScheme.outerCircleBackground}
        strokeWidth="2"
      />
    </svg>
  );
};

export const ShareSmallIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 14.625C15.1875 14.625 14.4688 14.957 13.9062 15.5215L10.8438 13.4629C11.0312 12.8652 11.0312 12.168 10.8438 11.5703L13.9062 9.51172C14.4688 10.043 15.1875 10.375 16 10.375C17.6562 10.375 19 8.94727 19 7.1875C19 5.42773 17.6562 4 16 4C14.3438 4 13 5.42773 13 7.1875C13 7.51953 13.0312 7.85156 13.125 8.15039L10.0625 10.209C9.5 9.64453 8.78125 9.3125 8 9.3125C6.34375 9.3125 5 10.7402 5 12.5C5 14.2598 6.34375 15.6875 8 15.6875C8.78125 15.6875 9.5 15.3555 10.0625 14.8242L13.125 16.8828C13.0312 17.1816 13 17.5137 13 17.8125C13 19.5723 14.3438 21 16 21C17.6562 21 19 19.5723 19 17.8125C19 16.0527 17.6562 14.625 16 14.625ZM16 5.59375C16.8125 5.59375 17.5 6.32422 17.5 7.1875C17.5 8.08398 16.8125 8.78125 16 8.78125C15.1562 8.78125 14.5 8.08398 14.5 7.1875C14.5 6.32422 15.1562 5.59375 16 5.59375ZM8 14.0938C7.15625 14.0938 6.5 13.3965 6.5 12.5C6.5 11.6367 7.15625 10.9062 8 10.9062C8.8125 10.9062 9.5 11.6367 9.5 12.5C9.5 13.3965 8.8125 14.0938 8 14.0938ZM16 19.4062C15.1562 19.4062 14.5 18.709 14.5 17.8125C14.5 16.9492 15.1562 16.2188 16 16.2188C16.8125 16.2188 17.5 16.9492 17.5 17.8125C17.5 18.709 16.8125 19.4062 16 19.4062Z"
      fill="currentColor"
    />
  </svg>
);

export const CloseIcon = ({ className, size = 24 }: { className?: string; size?: number }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    fill="#000000"
  >
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" />
  </svg>
);
export const Error404Icon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="602"
    height="273"
    viewBox="0 0 602 273"
    fill="none"
  >
    <path
      d="M162.6 175.8C166.2 175.8 168 177.6 168 181.2V189.9C168 193.5 166.2 195.3 162.6 195.3H142.5V216.6C142.5 221.8 144.7 226.5 149.1 230.7C153.5 234.9 155.7 238 155.7 240V240.9C155.7 244.3 153.5 246 149.1 246H91.8C87.4 246 85.2 244.3 85.2 240.9V240C85.2 238 87.2 234.9 91.2 230.7C95.2 226.5 97.2 221.8 97.2 216.6V195.3H12.9C4.9 195.3 0.9 192.1 0.9 185.7V184.2C0.9 178.8 2.3 173.9 5.1 169.5L88.5 44.4C93.5 36.8 100.2 33 108.6 33H135.6C140.2 33 142.5 35.3 142.5 39.9V175.8H162.6ZM25.2 175.8H97.2L97.5 68.1L25.2 175.8ZM287.709 249C260.909 249 238.609 239.1 220.809 219.3C203.209 199.3 194.409 172.7 194.409 139.5C194.409 106.1 202.609 79.5 219.009 59.7C235.609 39.9 258.209 30 286.809 30C313.409 30 335.509 40.3 353.109 60.9C370.909 81.3 379.809 107.8 379.809 140.4C379.809 173.2 371.009 199.5 353.409 219.3C335.809 239.1 313.909 249 287.709 249ZM294.609 231.6C305.809 231.6 314.909 225.4 321.909 213C328.909 200.6 332.409 183.2 332.409 160.8C332.409 142.4 330.309 124.7 326.109 107.7C321.909 90.7 315.709 76.6 307.509 65.4C299.509 54 290.409 48.3 280.209 48.3C268.609 48.3 259.309 54.8 252.309 67.8C245.309 80.6 241.809 99 241.809 123C241.809 141.8 243.909 159.4 248.109 175.8C252.509 192.2 258.709 205.6 266.709 216C274.909 226.4 284.209 231.6 294.609 231.6ZM562.045 175.8C565.645 175.8 567.445 177.6 567.445 181.2V189.9C567.445 193.5 565.645 195.3 562.045 195.3H541.945V216.6C541.945 221.8 544.145 226.5 548.545 230.7C552.945 234.9 555.145 238 555.145 240V240.9C555.145 244.3 552.945 246 548.545 246H491.245C486.845 246 484.645 244.3 484.645 240.9V240C484.645 238 486.645 234.9 490.645 230.7C494.645 226.5 496.645 221.8 496.645 216.6V195.3H412.345C404.345 195.3 400.345 192.1 400.345 185.7V184.2C400.345 178.8 401.745 173.9 404.545 169.5L487.945 44.4C492.945 36.8 499.645 33 508.045 33H535.045C539.645 33 541.945 35.3 541.945 39.9V175.8H562.045ZM424.645 175.8H496.645L496.945 68.1L424.645 175.8Z"
      fill="#e6e7ee"
    />
  </svg>
);

export const Success = () => (
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="30" cy="30" r="30" transform="rotate(-90 30 30)" fill="#A45A2A" />
    <path
      d="M36.2845 24.1277L27.0766 33.0809L23.7155 29.7787C23.5405 29.6426 23.2604 29.6426 23.1204 29.7787L22.105 30.766C21.965 30.9021 21.965 31.1745 22.105 31.3447L26.7965 35.8723C26.9716 36.0426 27.2166 36.0426 27.3917 35.8723L37.895 25.6596C38.035 25.5234 38.035 25.2511 37.895 25.0809L36.8797 24.1277C36.7396 23.9574 36.4595 23.9574 36.2845 24.1277Z"
      fill="white"
    />
  </svg>
);

export const SelectBoxArrowDown = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.8656 8.35464L19.6148 8.12371C19.4356 7.95876 19.1848 7.95876 19.0056 8.12371L12.0179 14.5567L4.9944 8.12371C4.81523 7.95876 4.56439 7.95876 4.38522 8.12371L4.13438 8.35464C3.95521 8.51959 3.95521 8.75052 4.13438 8.91546L11.6954 15.8763C11.8746 16.0412 12.1254 16.0412 12.3046 15.8763L19.8656 8.91546C20.0448 8.75052 20.0448 8.51959 19.8656 8.35464Z"
      fill="#292B29"
    />
  </svg>
);

export const SelectBoxArrowUp = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.13438 15.6454L4.38522 15.8763C4.56439 16.0412 4.81523 16.0412 4.9944 15.8763L11.9821 9.4433L19.0056 15.8763C19.1848 16.0412 19.4356 16.0412 19.6148 15.8763L19.8656 15.6454C20.0448 15.4804 20.0448 15.2495 19.8656 15.0845L12.3046 8.12371C12.1254 7.95876 11.8746 7.95876 11.6954 8.12371L4.13438 15.0845C3.95521 15.2495 3.95521 15.4804 4.13438 15.6454Z"
      fill="#292B29"
    />
  </svg>
);

export const WavyCircleIcon = () => (
  <>
    <Svg
      data-test="wavy-circle-icon"
      width="44"
      height="44"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-print="hide"
    >
      <circle cx="20" cy="20" r="20" />
      <path
        d="M34.338 17.626L34.7556 17.351L34.338 17.626L34.6337 18.0751C35.4029 19.2431 35.4029 20.7569 34.6337 21.9249L34.338 22.374C33.8046 23.1841 33.5471 24.1448 33.6041 25.1131L33.6356 25.6498C33.7177 27.0459 32.9608 28.3569 31.7107 28.9839L31.2301 29.2249C30.3631 29.6597 29.6597 30.3631 29.2249 31.2301L28.9839 31.7107C28.3569 32.9608 27.0459 33.7177 25.6498 33.6356L25.1131 33.6041C24.1448 33.5471 23.1841 33.8046 22.374 34.338L21.9249 34.6337C20.7569 35.4029 19.2431 35.4029 18.0751 34.6337L17.626 34.338L17.351 34.7556L17.626 34.338C16.8159 33.8046 15.8552 33.5471 14.8869 33.6041L14.3502 33.6356C12.9541 33.7177 11.6431 32.9608 11.0161 31.7107L10.7751 31.2301C10.3403 30.3631 9.63693 29.6597 8.7699 29.2249L8.2893 28.9839C7.03916 28.3569 6.28226 27.0459 6.36436 25.6498L6.39593 25.1131C6.45288 24.1448 6.19544 23.1841 5.66199 22.374L5.36629 21.9249C4.59711 20.7569 4.59711 19.2431 5.36629 18.0751L5.66199 17.626C6.19544 16.8159 6.45288 15.8552 6.39593 14.8869L6.36436 14.3502C6.28226 12.9541 7.03916 11.6431 8.2893 11.0161L8.7699 10.7751C9.63693 10.3403 10.3403 9.63693 10.7751 8.7699L11.0161 8.2893C11.6431 7.03916 12.9541 6.28226 14.3502 6.36436L14.8869 6.39593C15.8552 6.45288 16.8159 6.19544 17.626 5.66199L18.0751 5.36629C19.2431 4.59711 20.7569 4.59711 21.9249 5.36629L22.374 5.66199C23.1841 6.19544 24.1448 6.45288 25.1131 6.39593L25.6498 6.36436C27.0459 6.28226 28.3569 7.03916 28.9839 8.2893L29.2249 8.7699C29.6597 9.63693 30.3631 10.3403 31.2301 10.7751L31.7107 11.0161C32.9608 11.6431 33.7177 12.9541 33.6356 14.3502L33.6041 14.8869C33.5471 15.8552 33.8046 16.8159 34.338 17.626Z"
        stroke="#5A5E5A"
        strokeLinejoin="round"
      />
    </Svg>
  </>
);

export const CloseButton = ({
  width,
  backgroundColor = '#A45A2A',
}: {
  width?: string;
  backgroundColor?: string;
}) => (
  <svg width={width} height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <title>Close</title>
    <ellipse cx="40" cy="40" rx="40" ry="40" transform="rotate(-90 40 40)" fill={backgroundColor} />
    <line x1="47.0704" y1="32.9293" x2="32.928" y2="47.0717" stroke="white" strokeWidth="2" />
    <line x1="47.0722" y1="47.0714" x2="32.9298" y2="32.929" stroke="white" strokeWidth="2" />
    <circle cx="40.0003" cy="39.9998" r="30.8519" stroke="white" strokeWidth="2" />
  </svg>
);
CloseButton.defaultProps = { width: '80' };

export const RightArrow = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5781 6.1875L16.2031 6.51562C16.0156 6.75 16.0156 7.07812 16.2031 7.3125L20.1406 11.2031H2.5625C2.23438 11.2031 2 11.4844 2 11.7656V12.2344C2 12.5625 2.23438 12.7969 2.5625 12.7969H20.1406L16.2031 16.7344C16.0156 16.9688 16.0156 17.2969 16.2031 17.5312L16.5781 17.8594C16.7656 18.0938 17.1406 18.0938 17.375 17.8594L22.8125 12.4219C23.0469 12.1875 23.0469 11.8594 22.8125 11.625L17.375 6.1875C17.1406 5.95312 16.7656 5.95312 16.5781 6.1875Z"
      fill="#292B29"
    />
  </svg>
);

export const BlobUpperCorner = ({
  color,
  customSize,
}: {
  color?: string;
  customSize?: boolean;
}) => (
  <svg
    fill="none"
    height={customSize ? '100%' : '310'}
    viewBox="0 0 361 310"
    width={customSize ? '100%' : '361'}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m314.672 256.593c0 29.496-23.855 53.407-53.281 53.407-13.457 0-25.749-5.001-35.127-13.249-13.255-11.658-33.812-21.936-50.845-17.361-74.551 20.023-150.9033-23.291-170.53891-96.744-7.26889-27.192-5.746249-54.702 2.837-79.584 6.15311-17.8373-.81993-40.2597-3.51917-58.9383-.26302-1.8202-.39918-3.6815-.39917-5.5746 0-21.2901 17.21855-38.54910675 38.45875-38.5491 5.6905.00000057 11.0924 1.23882 15.9518 3.46207 14.0764 6.44012 31.1567 13.94533 46.1027 9.93113 50.853-13.65807 102.545 2.1544 136.501 36.9007 9.126 9.3378 22.076 14.1961 35.108 14.691 6.17.2343 12.418 1.123 18.656 2.7166 46.356 11.8428 74.605 58.1315 63.097 103.3895-4.293 16.883-13.513 31.238-25.793 41.986-11.605 10.159-17.209 28.072-17.209 43.516z"
      fill={color || '#EFDBB2'}
    />
  </svg>
);
export const BlobLowerCorner = () => (
  <svg
    fill="none"
    height="249"
    viewBox="0 0 326 249"
    width="326"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m170.421 47.1279c-24.774 7.3928-37.614-1.6974-51.93-4.9251-30.3951-6.8529-75.7596 2.3128-96.5814 28.4749-36.2679 45.5693-26.49792 113.6863 21.8219 152.1433 48.3199 38.457 116.8915 32.691 153.1595-12.879 11.274-14.165 26.181-34.999 45.252-43.481 19.071-8.483 43.702-18.614 60.545-37.289 23.923-26.527 29.181-53.9873 15.136-83.5071-14.045-29.5197-53.703-56.4149-89.294-40.59055s-33.335 34.66065-58.109 42.05355z"
      fill="#EFDBB2"
    />
  </svg>
);
export const BlobUpperCornerMobile = () => (
  <svg
    fill="none"
    height="143"
    viewBox="0 0 130 143"
    width="130"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m158.088 117.698c0 13.529-11.993 24.497-26.788 24.497-6.766 0-12.946-2.294-17.661-6.078-6.664-5.347-17.0002-10.061-25.5641-7.963-37.4822 9.184-75.8707-10.683-85.74307-44.3757-3.65463-12.4726-2.889082-25.0912 1.42638-36.5045 3.09366-8.1819-.41224-18.4668-1.76936-27.0346-.13224-.8349-.20069-1.6886-.20069-2.557 0-9.76562 8.65714-17.68220309 19.33624-17.6822 2.861.00000026 5.577.568236 8.0202 1.58803 7.0773 2.95403 15.6649 6.3966 23.1795 4.55531 25.5677-6.264834 51.5569.98823 68.6299 16.92616 4.588 4.2831 11.099 6.5116 17.651 6.7386 3.102.1074 6.244.5151 9.38 1.2461 23.307 5.4322 37.51 26.6646 31.724 47.4238-2.159 7.7443-6.794 14.3287-12.968 19.2589-5.835 4.6601-8.653 12.8761-8.653 19.9611z"
      fill="#EFDBB2"
    />
  </svg>
);
export const BlobLowerCornerMobile = () => (
  <svg
    fill="none"
    width="155"
    height="118"
    viewBox="0 0 155 118"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M61.2371 21.3286C66.4569 23.054 72.1489 24.9355 81.148 22.251C86.8121 20.5613 89.5089 17.6157 92.6581 14.1761C96.0676 10.4521 100.007 6.14893 108.817 2.2332C125.765 -5.29929 144.648 7.50299 151.336 21.5546C158.023 35.6062 155.52 48.6777 144.128 61.3046C136.617 69.6312 125.851 74.3893 117.055 78.2768C116.46 78.5396 115.874 78.7984 115.299 79.0541C107.157 82.6747 100.609 91.0221 95.472 97.5696C94.8801 98.3241 94.3069 99.0548 93.7522 99.7515C76.4828 121.443 43.8314 124.188 20.8233 105.882C-2.18478 87.5764 -6.8369 55.1523 10.4325 33.4608C20.3471 21.0075 41.948 16.6446 56.4209 19.9066C58.0374 20.271 59.6144 20.7922 61.2371 21.3286Z"
      fill="#EFDBB2"
    />
  </svg>
);
export const BlobUpperRight = () => (
  <svg
    fill="none"
    height="100%"
    viewBox="0 0 130 143"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#EFDBB2"
      d="m158.088 117.698c0 13.529-11.993 24.497-26.788 24.497-6.766 0-12.946-2.294-17.661-6.078-6.664-5.347-17.0002-10.061-25.5641-7.963-37.4822 9.184-75.8707-10.683-85.74307-44.3757-3.65463-12.4726-2.889082-25.0912 1.42638-36.5045 3.09366-8.1819-.41224-18.4668-1.76936-27.0346-.13224-.8349-.20069-1.6886-.20069-2.557 0-9.76562 8.65714-17.68220309 19.33624-17.6822 2.861.00000026 5.577.568236 8.0202 1.58803 7.0773 2.95403 15.6649 6.3966 23.1795 4.55531 25.5677-6.264834 51.5569.98823 68.6299 16.92616 4.588 4.2831 11.099 6.5116 17.651 6.7386 3.102.1074 6.244.5151 9.38 1.2461 23.307 5.4322 37.51 26.6646 31.724 47.4238-2.159 7.7443-6.794 14.3287-12.968 19.2589-5.835 4.6601-8.653 12.8761-8.653 19.9611z"
    />
  </svg>
);

export const CardVideo = () => (
  <Svg
    width="27"
    height="27"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="has video"
  >
    <path
      d="M11.125 6H4.35156C3.74219 6 3.25 6.51562 3.25 7.125V13.8984C3.25 14.5078 3.74219 15 4.35156 15H11.125C11.7344 15 12.25 14.5078 12.25 13.8984V7.125C12.25 6.51562 11.7344 6 11.125 6ZM15.5547 6.89062L13 8.67188V12.3516L15.5547 14.1328C16.0469 14.4609 16.75 14.1094 16.75 13.5234V7.5C16.75 6.91406 16.0469 6.5625 15.5547 6.89062Z"
      fill="#292B29"
    />
  </Svg>
);

export const ShefIcon = ({ className = '' }) => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10.25 1.25C9.82812 1.27344 9.21875 1.46094 8.89062 1.71875C8.32812 0.992188 7.48438 0.5 6.5 0.5C5.51562 0.5 4.64844 0.992188 4.08594 1.71875C3.75781 1.46094 3.14844 1.25 2.72656 1.25C1.48438 1.25 0.476562 2.25781 0.476562 3.5C0.476562 3.5 0.476562 3.5 0.5 3.5C0.5 4.48438 2 8.75 2 8.75V11.75C2 12.1719 2.32812 12.5 2.75 12.5H10.25C10.6484 12.5 11 12.1719 11 11.75V8.75C11 8.75 12.5 4.48438 12.5 3.5C12.5 2.28125 11.4688 1.25 10.25 1.25ZM3.125 11.375V9.5H9.875V11.375H3.125ZM9.92188 8.375H9.24219L9.5 5.23438V5.21094C9.5 5.11719 9.40625 5.02344 9.3125 5.02344L8.9375 5H8.91406C8.82031 5 8.75 5.07031 8.75 5.16406L8.49219 8.39844H6.85156V5.1875C6.85156 5.09375 6.75781 5 6.66406 5H6.28906C6.17188 5 6.10156 5.09375 6.10156 5.1875V8.375H4.48438L4.22656 5.16406C4.22656 5.07031 4.15625 5 4.03906 5L3.66406 5.02344C3.57031 5.02344 3.47656 5.11719 3.47656 5.21094V5.23438L3.73438 8.375H3.05469C2.375 6.42969 1.625 4.01562 1.625 3.5C1.60156 3.5 1.60156 3.5 1.60156 3.5C1.60156 2.89062 2.11719 2.39844 2.72656 2.39844C2.9375 2.39844 3.24219 2.49219 3.40625 2.60938L4.32031 3.3125L5 2.39844C5.35156 1.90625 5.89062 1.625 6.5 1.625C7.08594 1.625 7.625 1.90625 7.97656 2.39844L8.65625 3.3125L9.57031 2.60938C9.73438 2.49219 10.0391 2.39844 10.25 2.39844C10.8594 2.39844 11.375 2.89062 11.375 3.5C11.3516 4.01562 10.625 6.42969 9.92188 8.375Z"
      fill="#292B29"
    />
  </svg>
);

export const StarIcon = ({ className = '' }) => (
  <svg
    width="10"
    height="10"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 55.87 55.87"
    className={className}
  >
    <path d="M55.82 21.58a1 1 0 00-.81-.68l-18.09-2.63-8.09-16.4a1 1 0 00-1.8 0l-8.08 16.4L.85 20.9a1 1 0 00-.55 1.7l13.1 12.76-3.1 18.02a1 1 0 001.45 1.06l16.18-8.51 16.18 8.5a1 1 0 001.45-1.05l-3.09-18.02 13.1-12.76a1 1 0 00.25-1.02z" />
  </svg>
);

export const TimeIcon = ({ className = '' }) => (
  <svg
    width="11"
    height="13"
    viewBox="0 0 11 13"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M9.71094 4.8125L10.25 4.29688C10.3672 4.17969 10.3672 4.01562 10.25 3.89844L9.85156 3.5C9.73438 3.38281 9.57031 3.38281 9.45312 3.5L8.96094 3.99219C8.23438 3.33594 7.32031 2.91406 6.3125 2.79688V1.625H6.96875C7.10938 1.625 7.25 1.50781 7.25 1.34375V0.78125C7.25 0.640625 7.10938 0.5 6.96875 0.5H4.53125C4.36719 0.5 4.25 0.640625 4.25 0.78125V1.34375C4.25 1.50781 4.36719 1.625 4.53125 1.625H5.1875V2.79688C2.75 3.07812 0.875 5.14062 0.875 7.625C0.875 10.3203 3.05469 12.5 5.75 12.5C8.42188 12.5 10.625 10.3203 10.625 7.625C10.625 6.59375 10.2734 5.60938 9.71094 4.8125ZM5.75 11.375C3.66406 11.375 2 9.71094 2 7.625C2 5.5625 3.66406 3.875 5.75 3.875C7.8125 3.875 9.5 5.5625 9.5 7.625C9.5 9.71094 7.8125 11.375 5.75 11.375ZM6.03125 8.75C6.17188 8.75 6.3125 8.63281 6.3125 8.46875V5.28125C6.3125 5.14062 6.17188 5 6.03125 5H5.46875C5.30469 5 5.1875 5.14062 5.1875 5.28125V8.46875C5.1875 8.63281 5.30469 8.75 5.46875 8.75H6.03125Z"
      fill="#292B29"
    />
  </svg>
);

export const SeeMoreCardArrow = ({ className = '', dataTest = '' }) => (
  <svg
    preserveAspectRatio="none"
    width="21"
    height="21"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    data-test={dataTest}
  >
    <path
      d="M16.5781 6.1875L16.2031 6.51562C16.0156 6.75 16.0156 7.07812 16.2031 7.3125L20.1406 11.2031H2.5625C2.23438 11.2031 2 11.4844 2 11.7656V12.2344C2 12.5625 2.23438 12.7969 2.5625 12.7969H20.1406L16.2031 16.7344C16.0156 16.9688 16.0156 17.2969 16.2031 17.5312L16.5781 17.8594C16.7656 18.0938 17.1406 18.0938 17.375 17.8594L22.8125 12.4219C23.0469 12.1875 23.0469 11.8594 22.8125 11.625L17.375 6.1875C17.1406 5.95312 16.7656 5.95312 16.5781 6.1875Z"
      fill="currentColor"
    />
  </svg>
);

export const PlayVideo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Play video"
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    width="20"
    height="20px"
  >
    <g>
      <g>
        <path
          d="M256,0C114.608,0,0,114.608,0,256s114.608,256,256,256s256-114.608,256-256S397.392,0,256,0z M256,496
			C123.664,496,16,388.336,16,256S123.664,16,256,16s240,107.664,240,240S388.336,496,256,496z"
        />
      </g>
    </g>
    <g>
      <g>
        <polygon points="189.776,141.328 189.776,370.992 388.672,256.16 		" />
      </g>
    </g>
  </svg>
);

const WarningSvg = styled.svg<{
  $small?: boolean;
  children?: ReactNode;
  fill: string;
  viewBox: string;
  xmlns: string;
}>`
  width: 24px;
  height: 24px;
  ${(p) =>
    p.$small &&
    `@media (min-width: 768px) {
    width: 16px;
    height: 16px;
  }`}
`;

export const WarningIcon = ({ small = true }) => (
  <WarningSvg $small={small} fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 12C20 7.6129 16.3871 4 12 4C7.58065 4 4 7.6129 4 12C4 16.4194 7.58065 20 12 20C16.3871 20 20 16.4194 20 12ZM12 13.6129C12.8065 13.6129 13.4839 14.2903 13.4839 15.0968C13.4839 15.9355 12.8065 16.5806 12 16.5806C11.1613 16.5806 10.5161 15.9355 10.5161 15.0968C10.5161 14.2903 11.1613 13.6129 12 13.6129ZM10.5806 8.29032C10.5484 8.06452 10.7419 7.87097 10.9677 7.87097H13C13.2258 7.87097 13.4194 8.06452 13.3871 8.29032L13.1613 12.6774C13.129 12.9032 12.9677 13.0323 12.7742 13.0323H11.1935C11 13.0323 10.8387 12.9032 10.8065 12.6774L10.5806 8.29032Z"
      fill="#E22C43"
    />
  </WarningSvg>
);

export const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 12C20 7.6129 16.3871 4 12 4C7.58065 4 4 7.6129 4 12C4 16.4194 7.58065 20 12 20C16.3871 20 20 16.4194 20 12ZM11.0645 16.2581C10.871 16.4516 10.5161 16.4516 10.3226 16.2581L6.96774 12.9032C6.77419 12.7097 6.77419 12.3548 6.96774 12.1613L7.70968 11.4516C7.90323 11.2258 8.22581 11.2258 8.41935 11.4516L10.7097 13.7097L15.5484 8.87097C15.7419 8.64516 16.0645 8.64516 16.2581 8.87097L17 9.58065C17.1935 9.77419 17.1935 10.129 17 10.3226L11.0645 16.2581Z"
      fill="#8EDB23"
    />
  </svg>
);

export const CheckMarkIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.2845 6.12766L9.07659 15.0809L5.71554 11.7787C5.54048 11.6426 5.26039 11.6426 5.12035 11.7787L4.10503 12.766C3.96499 12.9021 3.96499 13.1745 4.10503 13.3447L8.7965 17.8723C8.97155 18.0426 9.21663 18.0426 9.39169 17.8723L19.895 7.65957C20.035 7.5234 20.035 7.25106 19.895 7.08085L18.8797 6.12766C18.7396 5.95745 18.4595 5.95745 18.2845 6.12766Z"
      fill="#292B29"
    />
  </svg>
);

export const PlusIcon = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.0469 11.1406H13.4844V4.57812C13.4844 4.41406 13.3203 4.25 13.1562 4.25H11.8438C11.6387 4.25 11.5156 4.41406 11.5156 4.57812V11.1406H4.95312C4.74805 11.1406 4.625 11.3047 4.625 11.4688V12.7812C4.625 12.9863 4.74805 13.1094 4.95312 13.1094H11.5156V19.6719C11.5156 19.877 11.6387 20 11.8438 20H13.1562C13.3203 20 13.4844 19.877 13.4844 19.6719V13.1094H20.0469C20.2109 13.1094 20.375 12.9863 20.375 12.7812V11.4688C20.375 11.3047 20.2109 11.1406 20.0469 11.1406Z"
      fill="#292B29"
    />
  </svg>
);

export const ShareIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" height="40" viewBox="0 0 40 40" width="40">
    <ellipse cx="20" cy="20" fill="#fff" rx="20" ry="20" transform="matrix(0 -1 1 0 0 40)" />
    <circle cx="20" cy="20" r="14.5" stroke="#292b29" />
    <path
      d="m23.0458 22.1367c-.6289 0-1.2031.2188-1.6406.5742l-2.8164-1.75c.0273-.1367.082-.4101.082-.5742 0-.1367-.0547-.4101-.082-.5469l2.8164-1.75c.4375.3555 1.0117.5469 1.6406.5469 1.4492 0 2.625-1.1484 2.625-2.625 0-1.4492-1.1758-2.625-2.625-2.625-1.4766 0-2.625 1.1758-2.625 2.625 0 .2188 0 .4102.0547.5742l-2.8164 1.75c-.4375-.3554-1.0117-.5742-1.6133-.5742-1.4766 0-2.625 1.1758-2.625 2.625 0 1.4766 1.1484 2.625 2.625 2.625.6016 0 1.1758-.1914 1.6133-.5469l2.8164 1.75c-.0273.1368-.0547.4102-.0547.5469 0 1.4766 1.1484 2.625 2.625 2.625 1.4492 0 2.625-1.1484 2.625-2.625 0-1.4492-1.1758-2.625-2.625-2.625z"
      fill="#292b29"
    />
  </svg>
);

export const FiltersIcon = () => (
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.4836 4H5.51636C4.17277 4 3.48535 5.62354 4.45399 6.5602L9.51591 11.6182V16.9883C9.51591 17.4879 9.73463 17.925 10.1096 18.2372L12.1094 19.7359C13.078 20.3915 14.5153 19.7671 14.5153 18.5182V11.6182L19.546 6.5602C20.5147 5.62354 19.8272 4 18.4836 4ZM13.0155 10.9937V18.487L11.0157 16.9883V10.9937L5.51636 5.49865H18.5149L13.0155 10.9937Z"
      fill="#292B29"
    />
  </svg>
);

export const SortByIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.88686 13.125C5.94155 13.125 5.4689 14.2422 6.1564 14.8867L11.2697 20C11.6564 20.4297 12.3009 20.4297 12.7306 20L17.8439 14.8867C18.4884 14.2422 18.0158 13.125 17.1134 13.125H6.88686ZM17.8439 8.61328L12.7306 3.5C12.3009 3.11328 11.6564 3.11328 11.2697 3.5L6.1564 8.61328C5.4689 9.30078 5.94155 10.375 6.88686 10.375H17.1134C18.0158 10.375 18.4884 9.30078 17.8439 8.61328Z"
      fill="#292B29"
    />
  </svg>
);

const InstagramSvg = styled.svg<{
  children?: ReactNode;
  fill: string;
  viewBox: string;
  xmlns: string;
}>`
  display: grid;
  width: 12px;
  height: 12px;
`;

export const Instagram = () => (
  <InstagramSvg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.00283 3.43872C5.08632 3.43872 3.54044 4.94165 3.54044 6.80493C3.54044 8.66821 5.08632 10.1711 7.00283 10.1711C8.91935 10.1711 10.4652 8.66821 10.4652 6.80493C10.4652 4.94165 8.91935 3.43872 7.00283 3.43872ZM7.00283 8.99341C5.76433 8.99341 4.75183 8.01196 4.75183 6.80493C4.75183 5.5979 5.76132 4.61645 7.00283 4.61645C8.24435 4.61645 9.25384 5.5979 9.25384 6.80493C9.25384 8.01196 8.24134 8.99341 7.00283 8.99341ZM11.4144 3.30103C11.4144 3.73755 11.0528 4.08618 10.6069 4.08618C10.1579 4.08618 9.79926 3.73462 9.79926 3.30103C9.79926 2.86743 10.1609 2.51587 10.6069 2.51587C11.0528 2.51587 11.4144 2.86743 11.4144 3.30103ZM13.7076 4.0979C13.6564 3.04614 13.4093 2.1145 12.6168 1.34692C11.8273 0.579346 10.869 0.339111 9.78721 0.286377C8.67225 0.224854 5.3304 0.224854 4.21544 0.286377C3.13665 0.336182 2.17839 0.576416 1.38587 1.34399C0.593346 2.11157 0.349261 3.04321 0.29502 4.09497C0.231738 5.17895 0.231738 8.42798 0.29502 9.51196C0.346247 10.5637 0.593346 11.4954 1.38587 12.2629C2.17839 13.0305 3.13364 13.2708 4.21544 13.3235C5.3304 13.385 8.67225 13.385 9.78721 13.3235C10.869 13.2737 11.8273 13.0334 12.6168 12.2629C13.4063 11.4954 13.6534 10.5637 13.7076 9.51196C13.7709 8.42798 13.7709 5.18188 13.7076 4.0979ZM12.2672 10.675C12.0322 11.2493 11.5772 11.6916 10.9835 11.9231C10.0946 12.2659 7.9852 12.1868 7.00283 12.1868C6.02047 12.1868 3.90808 12.2629 3.02214 11.9231C2.43152 11.6946 1.97649 11.2522 1.73844 10.675C1.38587 9.81079 1.46723 7.76001 1.46723 6.80493C1.46723 5.84985 1.38888 3.79614 1.73844 2.93481C1.97348 2.3606 2.4285 1.91821 3.02214 1.68677C3.91109 1.34399 6.02047 1.4231 7.00283 1.4231C7.9852 1.4231 10.0976 1.34692 10.9835 1.68677C11.5742 1.91528 12.0292 2.35767 12.2672 2.93481C12.6198 3.79907 12.5384 5.84985 12.5384 6.80493C12.5384 7.76001 12.6198 9.81372 12.2672 10.675Z"
      fill="#fff"
    />
  </InstagramSvg>
);

const FacebookSvg = styled.svg<{
  children?: ReactNode;
  fill: string;
  viewBox: string;
  xmlns: string;
}>`
  display: grid;
  width: 14px;
  height: 14px;
`;

export const Facebook = () => (
  <FacebookSvg viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.79297 8.68359L8.1818 6.14992H5.75067V4.50574C5.75067 3.81258 6.09028 3.13691 7.1791 3.13691H8.28434V0.979766C8.28434 0.979766 7.28137 0.808594 6.32242 0.808594C4.32031 0.808594 3.01164 2.02211 3.01164 4.21891V6.14992H0.786133V8.68359H3.01164V14.8086H5.75067V8.68359H7.79297Z"
      fill="#fff"
    />
  </FacebookSvg>
);

const TwitterSvg = styled.svg<{
  children?: ReactNode;
  fill: string;
  viewBox: string;
  xmlns: string;
}>`
  display: grid;
  width: 12px;
  height: 12px;
`;

export const Twitter = () => (
  <TwitterSvg viewBox="0 0 300 300.251" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M178.57 127.15 290.27 0h-26.46l-97.03 110.38L89.34 0H0l117.13 166.93L0 300.25h26.46l102.4-116.59 81.8 116.59h89.34M36.01 19.54H76.66l187.13 262.13h-40.66" />
  </TwitterSvg>
);

const YoutubeSvg = styled.svg<{
  children?: ReactNode;
  fill: string;
  viewBox: string;
  xmlns: string;
}>`
  display: grid;
  width: 12px;
  height: 8px;
`;

export const Youtube = () => (
  <YoutubeSvg viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.713 1.59944C12.5669 1.09133 12.1363 0.691166 11.5896 0.555363C10.5987 0.308594 6.62527 0.308594 6.62527 0.308594C6.62527 0.308594 2.65183 0.308594 1.66089 0.555363C1.11419 0.691188 0.683626 1.09133 0.537489 1.59944C0.271973 2.52041 0.271973 4.44193 0.271973 4.44193C0.271973 4.44193 0.271973 6.36345 0.537489 7.28442C0.683626 7.79253 1.11419 8.17602 1.66089 8.31182C2.65183 8.55859 6.62527 8.55859 6.62527 8.55859C6.62527 8.55859 10.5987 8.55859 11.5896 8.31182C12.1363 8.17602 12.5669 7.79253 12.713 7.28442C12.9786 6.36345 12.9786 4.44193 12.9786 4.44193C12.9786 4.44193 12.9786 2.52041 12.713 1.59944ZM5.32572 6.18653V2.69733L8.64675 4.44197L5.32572 6.18653Z"
      fill="#fff"
    />
  </YoutubeSvg>
);

export const StarSmallOutline = () => (
  <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.8813 4.69112L9.89061 4.11713L8.08661 0.481803C7.78595 -0.146862 6.85661 -0.174195 6.52862 0.481803L4.75195 4.11713L0.733966 4.69112C0.0233017 4.80046 -0.250031 5.67512 0.269301 6.19445L3.13929 9.00978L2.45596 12.9731C2.34663 13.6838 3.11196 14.2304 3.74062 13.9024L7.32128 12.0164L10.8746 13.9024C11.5033 14.2304 12.2686 13.6838 12.1593 12.9731L11.4759 9.00978L14.3459 6.19445C14.8653 5.67512 14.5919 4.80046 13.8813 4.69112ZM10.5193 8.68178L11.2846 13.1098L7.32128 11.0324L3.33063 13.1098L4.09596 8.68178L0.870633 5.56579L5.32595 4.90979L7.32128 0.864469L9.28927 4.90979L13.7446 5.56579L10.5193 8.68178Z"
      fill="#5A5E5A"
    />
  </svg>
);

export const StarSmall = () => (
  <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.52861 0.481803L4.75195 4.11713L0.733966 4.69112C0.0233017 4.80046 -0.250031 5.67512 0.269301 6.19445L3.13929 9.00978L2.45596 12.9731C2.34663 13.6838 3.11196 14.2304 3.74062 13.9024L7.32128 12.0164L10.8746 13.9024C11.5033 14.2304 12.2686 13.6838 12.1593 12.9731L11.4759 9.00978L14.3459 6.19445C14.8653 5.67512 14.5919 4.80046 13.8813 4.69112L9.8906 4.11713L8.08661 0.481803C7.78594 -0.146862 6.85661 -0.174195 6.52861 0.481803Z"
      fill="#5A5E5A"
    />
  </svg>
);

export const SelectBoxArrowDownWhite = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.8656 8.35464L19.6148 8.12371C19.4356 7.95876 19.1848 7.95876 19.0056 8.12371L12.0179 14.5567L4.9944 8.12371C4.81523 7.95876 4.56439 7.95876 4.38522 8.12371L4.13438 8.35464C3.95521 8.51959 3.95521 8.75052 4.13438 8.91546L11.6954 15.8763C11.8746 16.0412 12.1254 16.0412 12.3046 15.8763L19.8656 8.91546C20.0448 8.75052 20.0448 8.51959 19.8656 8.35464Z"
      fill="#fff"
    />
  </svg>
);

export const SelectBoxArrowUpWhite = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.13438 15.6454L4.38522 15.8763C4.56439 16.0412 4.81523 16.0412 4.9944 15.8763L11.9821 9.4433L19.0056 15.8763C19.1848 16.0412 19.4356 16.0412 19.6148 15.8763L19.8656 15.6454C20.0448 15.4804 20.0448 15.2495 19.8656 15.0845L12.3046 8.12371C12.1254 7.95876 11.8746 7.95876 11.6954 8.12371L4.13438 15.0845C3.95521 15.2495 3.95521 15.4804 4.13438 15.6454Z"
      fill="#fff"
    />
  </svg>
);

const LinkedInSvg = styled.svg<{
  children?: ReactNode;
  fill?: string;
  viewBox: string;
  xmlns: string;
  width: string;
  height: string;
}>`
  display: grid;
  width: 14px;
  height: 14px;
`;

export const LinkedIn = () => (
  <LinkedInSvg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.25992 9.23889H7.53656V19.7781H4.25992V9.23889ZM5.89833 4C6.94558 4 7.79666 4.85108 7.79666 5.90009C7.79666 6.94804 6.94558 7.79912 5.89833 7.79912C4.84862 7.79912 4 6.94804 4 5.90009C4 4.85108 4.84862 4 5.89833 4Z" />
    <path d="M9.59082 9.23852H12.7328V10.6797H12.7775C13.2148 9.85075 14.2837 8.97754 15.8768 8.97754C19.1938 8.97754 19.806 11.1597 19.806 13.9974V19.7778H16.5319V14.6525C16.5319 13.43 16.5106 11.858 14.8297 11.858C13.1251 11.858 12.865 13.1904 12.865 14.5647V19.7778H9.59082V9.23852Z" />
  </LinkedInSvg>
);

const XingSvg = styled.svg<{
  children?: ReactNode;
  viewBox: string;
  xmlns: string;
  width: string;
  height: string;
}>`
  display: grid;
  width: 14px;
  height: 14px;
`;

export const Xing = () => (
  <XingSvg width="14" height="16" viewBox="0 0 14 16" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.2251 3.3316L5.98742 6.36464L3.34384 11.0734C3.29073 11.168 3.19071 11.2265 3.08224 11.2265H0.512472C0.283133 11.2265 0.138606 10.9796 0.250878 10.7797L2.72956 6.36464L1.17864 3.63033C1.06521 3.43034 1.20967 3.18232 1.43959 3.18232H3.96571C4.0726 3.18232 4.17141 3.23919 4.2251 3.3316Z" />
    <path d="M5.37107 9.50276L10.6122 0.153304C10.6652 0.0586264 10.7653 0 10.8739 0H13.4858C13.7156 0 13.86 0.247628 13.747 0.447616L8.62893 9.50276L11.9913 15.5543C12.1024 15.7543 11.9579 16 11.7291 16H9.0717C8.96164 16 8.86041 15.9397 8.80796 15.843L5.37107 9.50276Z" />
  </XingSvg>
);
